var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kg-page"},[_c('div',{staticClass:"kg-container",attrs:{"id":"kg-container"}}),_c('KgMenu'),_c('KgRightbar'),_c('KgNodeDialog'),_c('KgEdgeDialog'),_c('KgClusterDialog'),_c('KgClusterNodeDialog'),_c('KgPathDialog'),_c('KgPathNodeDialog'),_c('KgResourceListBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }